import { MemberContactsListMember } from '../../../components/Member/Contacts';
import { usePageTitle } from '../../../hooks';

export function MemberContacts() {
  usePageTitle('vendor:contact.title');
  return <MemberContactsListMember />;
}
